// Copyright (c) Frisbii GmbH. All rights reserved.
"use strict";

const PgRequestLogsController = function ($scope, $http, PgRequestLogs) {
    $scope.loading = true;

    $scope.logLevels = [];
    
    $scope.pgRequestLogs = [];

    const getEmptyFilter = function () {
        return {
            Level: '',
            Message: '',
            After: '',
            Before: '',
        };
    };

    $scope.filter = getEmptyFilter();

    $scope.loadPage = function () {
        $http.get('/api/v1/paymentGateway/logs/loglevels', {cache: true}).then(function (result) {
            $scope.logLevels = result.data;
        });
    }

    $scope.loadPage();

    $scope.fetchPgRequestLogs = function () {
        $scope.loading = true;
        $scope.pgRequestLogs = $scope.paginator(function(options, callback) {
                return PgRequestLogs.query(options, function()
                {
                    callback();
                    $scope.loading = false;
                });
            },
            $scope.filter,
            100);
    }

    $scope.fetchPgRequestLogs();

    $scope.resetFilter = function () {
        $scope.filter = getEmptyFilter();
    };
};
PgRequestLogsController.$inject = ["$scope", "$http", "PgRequestLogs"];
